export default __webpack_public_path__ + "static/wordpress-259fd4961f4ae464313a02941b8428af.png";